/**
 * 本地储存的用户信息
 */
export const REFLECTION_KEY = 'reflection' as const

/**
 * 活动的 reflection
 */
export const ACTIVITY_REFLECTION_KEY = 'activity_reflection' as const

/**
 * bi 系列接口需要的 xRbacToken
 */
export const X_RBAC_TOKEN_KEY = 'xRbacToken' as const

/**
 * 本地储存的上一次存储 xRbacToken 的字符串时间戳
 */
export const LAST_SET_X_TOKEN_TIME_KEY = 'lastSetXTokenTimeString' as const

/**
 * 学校 id
 */
export const SCHOOL_ID_KEY = 'schoolId' as const

/**
 * 活动的学校 id
 */
export const ACTIVITY_SCHOOL_ID_KEY = 'activitySchoolId' as const

/**
 * 活动 id
 */
export const ACTIVITY_ID_KEY = 'activityId' as const

/**
 * 是否是教师管理界面
 */
export const IS_ADMIN_KEY = 'isAdmin' as const

/**
 * 本地用户主题颜色
 */
export const USER_THEME_COLOR = 'userThemeColor' as const

/**
 * 本地管理员主题颜色
 */
export const ADMIN_THEME_COLOR = 'adminThemeColor' as const

/**
 * 选择的角色，导师、书院长、学院长、全校
 */
export const SELECTED_ROLE_KEY = 'selected_data_board_role' as const

/**
 * 存储的行政班导师的行政班届别
 */
export const ADMINCLASS_MENTOR_GRADUATES_TERM =
  'adminclass_mentor_graduates_term'
